/**
 * Phase 45 Plan 45-05 — TanStack Query hook for /api/manager/portfolio.
 *
 * Stable query key `['manager', 'portfolio', period]` so claim / reassign /
 * status mutations elsewhere can `queryClient.invalidateQueries({ queryKey:
 * ['manager', 'portfolio'] })` without knowing the period. 60s `staleTime`
 * matches the backend's in-memory cache TTL — together they keep a manager
 * jumping between surfaces from re-hitting the DB on every focus change.
 *
 * Wired to `<ManagerRoute>` upstream so unauthorized callers never reach
 * this hook (backend `requireManager` is the defense-in-depth gate).
 */
import { useQuery } from '@tanstack/react-query';
import {
  fetchPortfolioOverview,
  type PortfolioPeriod,
  type PortfolioResponse,
} from '../services/api/portfolio';

export type { PortfolioPeriod };

export function usePortfolioOverview(period: PortfolioPeriod) {
  return useQuery<PortfolioResponse>({
    queryKey: ['manager', 'portfolio', period],
    queryFn: () => fetchPortfolioOverview(period),
    staleTime: 60_000,
  });
}
